module.exports = __webpack_public_path__ + "img/ftm.3af63018.svg";